module.exports = __webpack_public_path__ + "img/icon-game-10746.62325642.png";